/**
 * @author Fernando Ruano
 * @file useSearch.jsx
 * @description useSearch custom Hook.
 */

import React from 'react';

/**
 * useSearch custom hook.
 * @param { Array } rows - rows to filter.
 * @return { Object }
 */
const useSearch = (rows) => {
  const [searchTerm, setSearchTerm] = React.useState('');
  const [filteredRows, setFilteredRows] = React.useState(rows);

  React.useEffect(() => {
    try {
      const includeAnyColumn = (rowFormat) => {
        const searchTermTrim = searchTerm.toLowerCase().trim();
        const includeUserName = rowFormat.userName
          .toLowerCase()
          .includes(searchTermTrim);
        const includeNames = rowFormat.names
          .toLowerCase()
          .includes(searchTermTrim);
        const includeLastNames = rowFormat.lastNames
          .toLowerCase()
          .includes(searchTermTrim);
        const includeLastRoleName = rowFormat.roleName
          .toLowerCase()
          .includes(searchTermTrim);
        const includeLastProfile = rowFormat.profile
          .toLowerCase()
          .includes(searchTermTrim);
        const includeLastDefaultClinic = rowFormat.defaultClinic
          ?.toLowerCase()
          .includes(searchTermTrim);
        return (
          includeUserName ||
          includeNames ||
          includeLastNames ||
          includeLastRoleName ||
          includeLastProfile ||
          includeLastDefaultClinic
        );
      };
      const newRowsFiltered = rows.filter((rowFormat) =>
        includeAnyColumn(rowFormat)
      );
      setFilteredRows(newRowsFiltered);
    } catch (error) {
      setFilteredRows(rows);
    }
  }, [rows, searchTerm]);

  return { filteredRows, setSearchTerm, searchTerm, setFilteredRows };
};

export default useSearch;
